import { NocfoTheme } from '../styled'
import nocfoTheme from './nocfo'

export const theme: NocfoTheme = {
  ...nocfoTheme,
  colors: {
    neutralBlack: '#262C30',
    neutralGray: '#F0F2F5',
    neutralWhite: '#FFFFFF',
    iconGray: '#73808C',
    iconGrayDark: '#3B4A57',
    mutedYellow: '#F7CC7A',
    primary: '#3399ff',
    info: '#1b98f5',
    success: '#39d273',
    error: '#d61969',
    warning: '#ebcb4b',
    AIPurple: '#fd33ff',
    menuBg: '#102973',
    metalGray: '#425a70',
    backdrop: '#435a6f66',
    defaultHover: '#f6f7f9',
    dashboardPos: '#102973',
    dashboardNeg: '#ef8422',
    dashboardExtra1: '#58508d',
    dashboardExtra2: '#ffa600',
    ifBlue: '#0054f0',
    kraviaOrange: '#ff5e29',
    borderSoft: '#E4E8EC',
    borderStrong: '#CFD6DD'
  },
  assets: {
    logo: 'https://cdn.nocfo.io/third-party/talousyrittajat/logo-basic.svg',
    logoLight: 'https://cdn.nocfo.io/third-party/talousyrittajat/logo-white.svg'
  }
}

export default theme
